export const PUBLIC_BIO_CHARACTER_LIMIT = 3000;
export const PERSONAL_BIO_CHARACTER_LIMIT = 3000;
